import { render, staticRenderFns } from "./SucVerticalTableComponent.vue?vue&type=template&id=be426b42&scoped=true&"
import script from "./SucVerticalTableComponent.vue?vue&type=script&lang=js&"
export * from "./SucVerticalTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be426b42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be426b42')) {
      api.createRecord('be426b42', component.options)
    } else {
      api.reload('be426b42', component.options)
    }
    module.hot.accept("./SucVerticalTableComponent.vue?vue&type=template&id=be426b42&scoped=true&", function () {
      api.rerender('be426b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/vertical-build/SucVerticalTableComponent.vue"
export default component.exports